module.exports = __webpack_public_path__ + "img/cnd.97fd033c.jpg";